import * as actionTypes from '../../types/general';

const initState = {
  darkMode: 0,
  darkModeFetching: false,
  error: false,
  showFixedAlert: false,
  backPath: '',
  guidesPortal: false,
  guidesParams: {},
};

const general = (state = initState, action) => {
  switch (action.type) {
  case actionTypes.CHANGE_VIEW_MODE: {
    return {
      ...state,
      darkMode: !state.darkMode,
      darkModeFetching: true,
    };
  }
  case actionTypes.CHANGE_VIEW_MODE_ERROR: {
    return {
      ...state,
      error: true,
      darkModeFetching: false,
    };
  }
  case actionTypes.CHANGE_VIEW_MODE_SUCCESS: {
    return {
      ...state,
      darkMode: action.payload,
      darkModeFetching: false,
    };
  }
  case actionTypes.TOGGLE_FIXED_ALERT: {
    return {
      ...state,
      showFixedAlert: action.showAlert,
      backPath: action.path || '',
    };
  }
  case actionTypes.TOGGLE_GUIDES_PORTAL: {
    return {
      ...state,
      guidesPortal: action.value,
      guidesParams: action.data,
    };
  }

  default: {
    return state;
  }
  }
};

export default general;
